import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { LocalStorageService } from '../local/local-storage.service';
import { FuseUtilsService } from '@fuse/services/utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(
    private _authService: AuthService,
    private _localService: LocalStorageService,
    private _fuseUtilsService: FuseUtilsService
  ) {}

  /**
   * Intercept outgoing requests and handle 401 responses
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req.clone();

    // 🔹 Get token from AuthService or fallback to LocalStorage
    const token =
      this._authService.accessToken || this._localService.getItem('accessToken');

    // 🔹 Attach Authorization header if token exists and is not expired
    if (token && !AuthUtils.isTokenExpired(token)) {
      newReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // 🔹 Debug (optional)
    // console.log('Intercepted request:', newReq.url);
    // console.log('Token attached:', !!token);

    // 🔹 Handle response and catch 401 errors
    return next.handle(newReq).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Handle Unauthorized responses
          const user = this._localService.getItem('user');

          if (user && !user.isSuperAdmin) {
            // Regular user logout
            this._authService.userLogout(user.id).subscribe({
              next: () => {
                this._localService.clear();
                location.reload();
              },
              error: () => {
                this._localService.clear();
                location.reload();
              },
            });
          } else {
            // Super admin or no user stored
            this._localService.clear();
            location.reload();
          }
        }

        return throwError(() => error);
      })
    );
  }
}


// const concatenateStringsCharByChar = (str1, str2): any => {
//     const maxLength = Math.max(str1.length, str2.length);
//     let result = '';
//     for (let i = 0; i < maxLength; i++) {
//         if (i < str1.length) {
//             result += str1[i];
//         }
//         if (i < str2.length) {
//             result += str2[i];
//         }
//     }
//     return result;
// };

// const formatDate = (date): any => {
//     const d = new Date(date);
//     let month = '' + (d.getMonth() + 1);
//     let day = '' + d.getDate();
//     const year = d.getFullYear();

//     if (month.length < 2) { month = '0' + month; }
//     if (day.length < 2) { day = '0' + day; }

//     return [year, month, day].join('-');
// };



